// Copyright © 2021 Move Closer

export const defaultDateFormat = 'DD.MM.YYYY (HH:mm)'
